var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"m-table-cell-container",class:{
    'm-table-cell-container_left': _vm.alignLeft,
    'm-table-cell-container_right': _vm.alignRight,
    'm-table-cell-container_center': _vm.alignCenter,
    'm-table-cell-container_sortable': _vm.sortable,
    'm-table-cell-container_right-border': _vm.hasRightBorder,
    'm-table-cell-container_sticky-column': _vm.sticky,
    'm-table-cell-container_column-sticked': _vm.isColumnSticked,
    'm-table-cell-container_is-first': _vm.isFirst,
    'm-table-cell-container_is-last': _vm.isLast,
    'm-table-cell-container_last-nested-row-cell': _vm.isLastRow && _vm.isNested
  },style:(_vm.cssVars)},[(_vm.sticky)?_c('div',{staticClass:"m-table-column__sticky-trigger"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }